module.exports = __webpack_public_path__ + "static/media/crow.b7c09d4a.mp3";